import { defineMessages } from 'react-intl'

export default defineMessages({
    title: {
        id: 'containers.NewUser.components.Coordinator.title',
        defaultMessage: 'Create project manager',
    },
    subtitle: {
        id: 'containers.NewUser.components.Coordinator.subtitle',
        defaultMessage: 'Please add all the necessary info to create a new project manager.',
    },
    coordinatorNameLabel: {
        id: 'containers.NewUser.components.Coordinator.coordinatorName',
        defaultMessage: 'Name',
    },
    coordinatorNameDescription: {
        id: 'containers.NewUser.components.Coordinator.coordinatorNameDescription',
        defaultMessage: 'Full name',
    },
    coordinatorNamePlaceholder: {
        id: 'containers.NewUser.components.Coordinator.coordinatorNamePlaceholder',
        defaultMessage: 'Full name',
    },
    coordinatorEmailLabel: {
        id: 'containers.NewUser.components.Coordinator.coordinatorEmailLabel',
        defaultMessage: 'E-mail',
    },
    coordinatorEmailDescription: {
        id: 'containers.NewUser.components.Coordinator.coordinatorEmailDescription',
        defaultMessage: 'E-mail',
    },
    coordinatorEmailPlaceholder: {
        id: 'containers.NewUser.components.Coordinator.coordinatorEmailPlaceholder',
        defaultMessage: 'E-mail',
    },
    coordinatorPhoneLabel: {
        id: 'containers.NewUser.components.Coordinator.coordinatorPhoneLabel',
        defaultMessage: 'Phone',
    },
    coordinatorPhoneDescription: {
        id: 'containers.NewUser.components.Coordinator.coordinatorPhoneDescription',
        defaultMessage: 'Phone number',
    },
    coordinatorPhonePlaceholder: {
        id: 'containers.NewUser.components.Coordinator.coordinatorPhonePlaceholder',
        defaultMessage: 'Phone number',
    },
    coordinatorPartnerLabel: {
        id: 'containers.NewUser.components.Coordinator.coordinatorPartnerLabel',
        defaultMessage: 'Partner',
    },
    coordinatorPartnerDescription: {
        id: 'containers.NewUser.components.Coordinator.coordinatorPartnerDescription',
        defaultMessage: 'Partner',
    },
    coordinatorPartnerPlaceholder: {
        id: 'containers.NewUser.components.Coordinator.coordinatorPartnerPlaceholder',
        defaultMessage: 'Partner',
    },
    submit: {
        id: 'containers.NewUser.components.Coordinator.submit',
        defaultMessage: 'Create project manager',
    },
    errorsPresent: {
        id: 'containers.NewUser.components.Coordinator.errorsPresent',
        defaultMessage: 'Must be filled out',
    },
    errorsEmail: {
        id: 'containers.NewUser.components.Coordinator.errorsEmail',
        defaultMessage: 'E-mail must be a valid e-mail',
    },
    errorsPhone: {
        id: 'containers.NewUser.components.Coordinator.errorsPhone',
        defaultMessage: 'Must be a valid phone number',
    },
    phoneNumberSearchPlaceholder: {
        id: 'containers.SupplierProfile.components.Basics.phoneNumber.placeholder.search',
        defaultMessage: 'Search',
    },
    phoneNumberNotFoundPlaceholder: {
        id: 'containers.SupplierProfile.components.Basics.phoneNumber.placeholder.notfound',
        defaultMessage: 'Not found',
    },
})